module.exports = __webpack_public_path__ + "static/media/dataDownload.b430100a.md";